<template>
  <router-link :to="{ name: 'boxEdit', params: { locale: i18n.locale, boxId: box.id }}" class="kp-select-open mobile-hide">
    <i class="icon-kp-edit"></i>{{ $t('general.actions.edit') }}
  </router-link>
</template>

<script>
import i18n from '../../../../i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  props: [
    'box',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** ButtonEdit.vue?65a88d55
 **/